/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ThemeMidnightIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACKElEQVR4nO1USWsUURAOiHtERRC8eFIIiKI3QcRTYGC6lh54UzWTCQMRBgSDeFLjnwhuoCHJyYNXvUXNIYngJQQXkICguQVCoqBoDjpKdb+W6dg9WdB4saBo3ut6X21fVUfHZkmj0diKpFP2/TvgLJeQ9Yd9/7gTJJ2Kwb2STG5aBkTVk8hyG0hngfSLKZK8QdJHwDIDpB+jO9Y5YB0H0n7n3M5sJySTCfi5en0Hst5F1mYquzUosLxk7j2Qm5FFAKwTawYleRoE7jCRiGUaO9GRXAdAci8/Or3W3V3bDSQD6X9yw94WS5Wj/ryQCY6op9qVxTnXGdvhnpRj0m9hWDtYLFb3+/OnvOiH29aXZMCcIMv1FQ4GY1KI+Eyf/Q7OWttYU/WxkcOz8bVv9IUUOJGcRdbl9YIj65MgCHb57G/5bN4aC3+BmwGwvls3OOmdQqGw3ffusr9fhlL5zIq6a79/8CrS1cHnAqpwS9+u+PsmhuWejNrL88ggFGfNygeWBWS5ajSNy1rfhyQPWgZsKIc50agbBfcGpUqXUa5liL4iyRiw1hOKOue22BlZ5lvY9R1Aj2Vzn2UpMgJ3xLOpEpD0Qlg+ndTYxCJH1r5kWrMGLceBjvruz2JY1jDsOeSc22YlANATQHIeWO/b8OSsirHMBZeILSZkebEBijYt8hQl2y84uWiLC0neI8tnIF1E0mlgeWgbElg+RP2J2XaTqHp8VeD/8s/lJzl9AVA7sVNWAAAAAElFTkSuQmCC)
 */
export const ThemeMidnightIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="m3.83 1.23.53 1.41 1.41.53c.3.12.3.54 0 .66l-1.41.53-.53 1.41c-.12.3-.54.3-.66 0l-.53-1.41-1.41-.53a.35.35 0 0 1 0-.66l1.41-.53.53-1.41c.12-.3.54-.3.66 0Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M12 4a8 8 0 0 0-7.67 5.7c-2.88 2.8-4.11 5.97-2.82 8.12 1.23 2.04 4.43 2.64 8.16 1.84a8 8 0 0 0 10-5.36c2.88-2.8 4.11-5.97 2.82-8.12-1.23-2.04-4.43-2.64-8.16-1.84A8 8 0 0 0 12 4Zm8.06 6.7c1.14-1.78 1.05-2.93.72-3.48-.36-.59-1.38-1.24-3.49-1.22.8.71 1.47 1.58 1.94 2.57l-.24.4a16.52 16.52 0 0 1-5.91 5.21 17.33 17.33 0 0 1-7.7 2.32 7.95 7.95 0 0 1-1.3-3.41l-.14.21c-1.14 1.78-1.05 2.93-.72 3.48.36.6 1.43 1.27 3.65 1.22 2.12-.05 4.8-.78 7.46-2.26a16.02 16.02 0 0 0 5.73-5.04ZM13.5 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
